import { AbstractControl, FormGroup, FormArray } from '@angular/forms';
import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import { Profile } from '../enum/profile.enum';
import { StorageNames } from '../enum/storage-names.enum';
import { IAuthenticationUser } from '../interfaces/authentication-user.interface';
import { IUserProfile } from '../interfaces/user-profile.interface';
import { ICompanyProfile } from '../interfaces/company-profile.interface';

@Injectable()
export class SharedPrefService {
    /**
     * Creates an instance of shared pref service.
     * @param storageService StorageService
     */
    constructor(private storageService: StorageService) {}

    get auth() {
        return this.storageService.get<IAuthenticationUser>(StorageNames.USER);
    }
    /**
     * Profiles shared pref service
     * @returns Profile
     */
    profile(): Profile {
        return this.auth.profile;
    }
    /**
     * Users shared pref service
     * @returns IAuthenticationUser
     */
    user(): IUserProfile | ICompanyProfile {
        return this.auth.user;
    }
    /**
     * Sets user
     * @param {IUserProfile | ICompanyProfile} user
     */
    setUser(user: IUserProfile | ICompanyProfile): IAuthenticationUser {
        const userInfo = { ...this.auth, user } as IAuthenticationUser;

        this.storageService.set(StorageNames.USER, userInfo);

        return userInfo;
    }
}
